import { render, staticRenderFns } from "./relevanceContent.vue?vue&type=template&id=ecbaae80"
import script from "./relevanceContent.vue?vue&type=script&lang=js"
export * from "./relevanceContent.vue?vue&type=script&lang=js"
import style0 from "./relevanceContent.vue?vue&type=style&index=0&id=ecbaae80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports